export default __webpack_public_path__ + "static/media/profile.4582b145.svg";